module.exports = __webpack_public_path__ + "assets/img/12-1.1137f630.png";